// Registers the offline service worker in production builds, scoped to
// /offline only (no trailing slash: a scope is a path prefix, and
// /offline/ would not cover the /offline URL itself). A worker that controls a page is consulted for every
// request that page makes, images included, and on iOS that alone changes
// how images load (back-nav flicker, measured 2026-10-21). So the normal
// app runs with no worker at all; only /offline and /offline/read/... are
// served without network. A new build takes over on the next load; we do
// not interrupt the reader mid-page.
const SCOPE = '/offline';

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      // Earlier builds registered at the root; that worker keeps
      // controlling every page until it is gone.
      .then((regs) => Promise.all(regs.filter((r) => ![SCOPE, "/push/"].includes(new URL(r.scope).pathname)).map((r) => r.unregister())))
      .then(() => navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`, { scope: SCOPE }))
      .then((reg) => {
        reg.onupdatefound = () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.onstatechange = () => {
            // New version installed: activate it now, unless this page is
            // itself an offline page the old version is serving (the
            // reader must not change under the user mid-page).
            if (sw.state === 'installed' && reg.active && !window.location.pathname.startsWith(SCOPE)) {
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          };
        };
        // The browser checks a worker for updates only on navigations inside
        // its scope, and people open /offline only without network. So check
        // on every online load of the app; otherwise the offline copy stays
        // on the build it was first saved with (verified 2026-10-28).
        if (navigator.onLine !== false) reg.update().catch(() => {});
      }).catch((e) => console.error('service worker registration failed', e));
  });
}
